'use client'

import { useContext, useMemo, useState } from 'react'
import { GlobalContext } from 'src/components/layout/GlobalContext'
import CookieBot from 'src/components/cookies/CookietBot'
import { createJournalDomainRoutes } from 'src/_helpers/journalDomainRoutes'

export default function AppJournalContextProvider({
  children,
  currentLocale,
  translatorEntries,
  journalDefaultLocale = null,
  journalLocales = null,
  siteOrigin = null,
  cookieConsent = null,
}) {
  const parentContext = useContext(GlobalContext)
  const [langChangerState, setLangChangerState] = useState(null)
  const [cookiesShowModal, setCookiesShowModal] = useState(false)
  const journalLocalesKey = Array.isArray(journalLocales) ? journalLocales.join(',') : ''
  const journalDomainRoutes = useMemo(() => {
    if (!journalDefaultLocale) {
      return null
    }

    return createJournalDomainRoutes({
      defaultLocale: journalDefaultLocale,
      locales: journalLocalesKey ? journalLocalesKey.split(',') : [],
    })
  }, [journalDefaultLocale, journalLocalesKey])

  return (
    <GlobalContext.Provider
      value={{
        ...parentContext,
        currentLocale,
        translatorEntries,
        journalDomainRoutes: journalDomainRoutes || parentContext.journalDomainRoutes || null,
        siteOrigin: siteOrigin || parentContext.siteOrigin || null,
        siteDefaultLocale: journalDefaultLocale || parentContext.siteDefaultLocale || null,
        langChangerState,
        setLangChangerState,
        openCookiesModal: parentContext.openCookiesModal || (() => setCookiesShowModal(true)),
      }}
    >
      {children}
      {cookieConsent && (
        <CookieBot
          config={cookieConsent.config}
          cookies={cookieConsent.cookies}
          privacyPolicyPage={cookieConsent.privacyPolicyPage}
          privacyPolicyBaseUrl={cookieConsent.privacyPolicyBaseUrl}
          hostOnlyGaCookies
          externalShowModal={cookiesShowModal}
          setExternalShowModal={setCookiesShowModal}
        />
      )}
    </GlobalContext.Provider>
  )
}
